<template>
  <p class="universal-login" data-testid="universal_login__message">{{ $t('label.redirecting') }}</p>
</template>

<script>
import { isUniversalLoginEnabled, redirectToUniversalLogin, UNIVERSAL_LOGIN_FAILED_ROUTE } from '@/libs/universalLogin';

// /sign_in/universal_login: Auth0 の Universal Login への入口。ログイン画面にボタンは置かず、URL で到達する
export default {
  name: 'universal-login',
  async created() {
    if (!isUniversalLoginEnabled()) {
      this.$router.replace('/sign_in');
      return;
    }
    try {
      await redirectToUniversalLogin({ redirectTo: this.$route.query.redirectTo });
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      this.$router.replace(UNIVERSAL_LOGIN_FAILED_ROUTE);
    }
  },
};
</script>

<i18n lang="yaml">
ja:
  label:
    redirecting: 'Auth0 のログイン画面へ移動しています…'

en:
  label:
    redirecting: 'Redirecting to the Auth0 login page…'
</i18n>
